'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _players = require('../../store/actions/players');

var dataHudlElement = 'vi-controls-restart';
var iconName = 'replay';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isHidden: ownProps.isHidden,
    isInactive: ownProps.isInactive,
    title: 'Replay',
    iconName: iconName,
    dataHudlElement: dataHudlElement
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps, _ref) {
  var playerId = _ref.playerId;

  return {
    onClick: function onClick() {
      dispatch((0, _players.setCurrentTimeMs)(playerId, 0, { ofClip: true }));
    }
  };
};

exports.default = {
  mapStateToProps: mapStateToProps,
  mapDispatchToProps: mapDispatchToProps
};
module.exports = exports['default'];